import { useRef } from 'react';
import * as motion from 'framer-motion/client';
// import { useScroll, useMotionValueEvent, useInView } from 'framer-motion';
import { useInView } from 'framer-motion';
import styles from './bewithus.module.scss';
import Image from 'next/image';
import T from '../../../common/components/T';
import uikit from '../../../project/uikit/uikit.module.scss';
import classNames from 'classnames';
import { svgSprite } from '../../../hybrid/wrappers';
//import Link from 'next/link';

const BeWithUsPage = () => {
    const sectionRef = useRef();
    const isInView = useInView(sectionRef);
    const topLevelDomain = typeof window !== 'undefined' && window.location.host.split('.').pop();
    const socials = [
        topLevelDomain != 'ru'
            ? {
                  link: 'https://www.instagram.com/globaltrend.official/?igshid=1d49f4t3wja7w',
                  //image: '/src/landing/social/social-1.svg',
                  image: 'instagram',
                  title: <T textName={'landing-social-Instagram'} defaultStr={'Instagram'} page='/' />
              }
            : false,
        {
            link: 'https://www.youtube.com/channel/UCZRq8VHhgB5vhqaR0t5HsAQ',
            //image: '/src/landing/social/social-2.svg',
            image: 'youtube',
            title: <T textName={'landing-social-YouTube'} defaultStr={'YouTube'} page='/' />
        },
        {
            link: 'https://t.me/globaltrendofficial1',
            image: 'telegram',
            //image: '/src/landing/social/social-3.svg',
            title: <T textName={'landing-social-telegram1'} defaultStr={'Telegram'} page='/' />
        }
    ].filter((i) => i != false);
    return (
        <section className={styles.bewithusWrapperOuter}>
            <motion.div
                className={styles.ellips4Wrapper}
                style={{
                    transition: 'transform 0.25s linear',
                    y: !isInView ? '150%' : 0,
                    x: !isInView ? '-30%' : 0
                }}
            >
                <Image src={'ellipse.svg'} alt='ellipse icon5' width={377} height={377} />
            </motion.div>
            <motion.div
                ref={sectionRef}
                className={styles.bewithusWrapperMain}
                style={{
                    transition: 'transform 0.25s linear',
                    y: isInView ? 0 : '25%',
                    scale: isInView ? 1 : 0.5
                }}
                transition={{
                    duration: 0.25
                }}
            >
                <div className={classNames(uikit.container, uikit.positionRelative, styles.bewithusWrapper)}>
                    <div className={styles.bewithusBlockStatic}>
                        <motion.h2
                            initial={{ y: '150%' }}
                            animate={!isInView ? {} : { y: 0 }}
                            transition={{ duration: 0.25, ease: 'linear' }}
                            className={styles.bewithusTitleStatic}
                        >
                            <T textName={'landing-bewithus-new-social'} defaultStr={'Social Media'} page='/' />
                        </motion.h2>
                    </div>
                    <div className={styles.mainContentWrapper}>
                        <motion.div
                            // className={styles.borderBottom}
                            initial={{ width: 0 }}
                            animate={!isInView ? { width: 0 } : { width: '100%' }}
                            transition={{ duration: 0.25, ease: 'linear' }}
                        />
                        <div className={classNames(uikit.row, uikit.justifyContentBetween)}>
                            <div className={classNames(uikit.col_xl_5, uikit.col_lg_6)}>
                                <div className={styles.textWrapper}>
                                    <div className={styles.textBlock}>
                                        <motion.h2
                                            initial={{ y: '150%' }}
                                            animate={!isInView ? { y: '150%' } : { y: 0 }}
                                            transition={{ duration: 0.4, ease: 'linear' }}
                                            className={styles.bewithusTitle}
                                        >
                                            <T textName={'landing-bewithuspage-new1'} defaultStr={'Будьте с нами'} page='/' />
                                        </motion.h2>
                                    </div>
                                </div>
                                <div className={styles.descriptionWrapper}>
                                    <div className={styles.descriptionBlock}>
                                        <motion.p
                                            initial={{ y: '120%' }}
                                            animate={!isInView ? { y: '120%' } : { y: 0 }}
                                            transition={{ duration: 0.4, ease: 'linear' }}
                                            className={styles.descriptionText}
                                        >
                                            <T
                                                textName={'landing-bewithuspage-new3'}
                                                defaultStr={'Подписывайтесь и будьте активными'}
                                                page='/'
                                            />
                                        </motion.p>
                                    </div>
                                    <div className={styles.descriptionBlock}>
                                        <motion.p
                                            initial={{ y: '120%' }}
                                            animate={!isInView ? { y: '120%' } : { y: 0 }}
                                            transition={{ duration: 0.4, ease: 'linear' }}
                                            className={styles.descriptionText}
                                        >
                                            <T
                                                textName={'landing-bewithuspage-new4'}
                                                defaultStr={'подписчиками наших социальных сетей'}
                                                page='/'
                                            />
                                        </motion.p>
                                    </div>
                                </div>
                            </div>
                            <div className={classNames(uikit.col_xxl_6, uikit.col_xl_7, uikit.col_lg_6)}>
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={!isInView ? { opacity: 0 } : { opacity: 1 }}
                                    transition={{ duration: 0.25, ease: 'linear' }}
                                    className={styles.socialsWrapper}
                                >
                                    {socials.map((item, index) => {
                                        return (
                                            <a
                                                href={item?.link}
                                                target={'_blank'}
                                                key={index}
                                                className={styles.socialItem}
                                                rel='noopener noreferrer'
                                            >
                                                <span className={styles.itemImage}>
                                                    {svgSprite(item.image, {
                                                        fill: 'currentColor',
                                                        className: styles.socialItemSvg
                                                    })}
                                                    {/*<Image fill src={item.image} alt={`${item.image}_${index}`} />*/}
                                                </span>
                                                <span className={styles.socialTitle}>{item.title}</span>
                                            </a>
                                        );
                                    })}
                                </motion.div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.mobileLine}></div>
                    {/* <div className={styles.bewithusBlockStaticBottom}>
                        <motion.h2
                            initial={{ y: '120%' }}
                            animate={!isInView ? {} : { y: 0 }}
                            transition={{ delay: 0.75, duration: 1, ease: 'linear' }}
                            className={styles.bewithusTitleStatic}
                        >
                            <T textName={'landing-carouselpage-new27'} defaultStr={'Global Trend'} page='/' />
                        </motion.h2>
                         </div> */}
                </div>
            </motion.div>
        </section>
    );
};
export default BeWithUsPage;
